import { Subject } from 'rxjs';

const subject = new Subject();

export const MaisServicosService = {
    send: (res: boolean) => subject.next(res),
    get: () => subject.asObservable()
};